import { Label } from "design-system/atoms/Label"
import { Textarea } from "design-system/atoms/Textarea"
import { useTranslation } from "react-i18next"
import { EmojiInput } from "../../../shared/components/Miscelanea/EmojiInput"

export type ReactToMessageConfig = { emojis: string; definition: string }

type Props = {
  value: ReactToMessageConfig
  onChange: (value: ReactToMessageConfig) => void
}

export function ReactToMessageFields({ value, onChange }: Props) {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-1.5">
        <Label>{t("capabilities.catalog.ReactToMessage.config.emojis.label")}</Label>
        <EmojiInput
          value={value.emojis}
          onChange={(e) => onChange({ ...value, emojis: e.target.value })}
        />
        <p className="text-sm text-muted-foreground">
          {t("capabilities.catalog.ReactToMessage.config.emojis.description")}
        </p>
      </div>
      <div className="flex flex-col gap-1.5">
        <Label>{t("capabilities.catalog.ReactToMessage.config.definition.label")}</Label>
        <Textarea
          value={value.definition}
          onChange={(e) => onChange({ ...value, definition: e.target.value })}
          placeholder={t("capabilities.catalog.ReactToMessage.config.definition.placeholder")}
          rows={4}
          maxLength={1024}
        />
        <p className="text-sm text-muted-foreground">
          {t("capabilities.catalog.ReactToMessage.config.definition.description")}
        </p>
      </div>
    </div>
  )
}
